const PRODUCTION = `//${window.location.host}`
const DEVELOPMENT = `http://${window.location.hostname}:3000`

const BASE_URL = APP_ENV === 'production' ? PRODUCTION : DEVELOPMENT
const SERVICE_URL = `${BASE_URL}/api/`

export {
  BASE_URL,
  SERVICE_URL
}


// WEBPACK FOOTER //
// ./src/service/ServiceURL.js